module.exports = __webpack_public_path__ + "img/1100.4f7245fc.gif";